import { useState } from 'react';

const NssTrunkRemovalModal = ({
    isOpen,
    onClose,
    trunkData,
    onConfirmRemoval,
    onSubmitExplanation,
    isLoading
}) => {
    const [showExplanationForm, setShowExplanationForm] = useState(false);
    const [explanation, setExplanation] = useState('');
    const [explanationError, setExplanationError] = useState('');

    if (!isOpen || !trunkData) return null;

    const handleYesClick = async () => {
        await onConfirmRemoval(trunkData);
    };

    const handleNoClick = () => {
        setShowExplanationForm(true);
        setExplanationError('');
    };

    const handleSubmitExplanation = async () => {
        if (!explanation.trim()) {
            setExplanationError('Please provide an explanation');
            return;
        }
        if (explanation.trim().length < 10) {
            setExplanationError('Explanation must be at least 10 characters');
            return;
        }
        await onSubmitExplanation(trunkData, explanation);
        setExplanation('');
        setShowExplanationForm(false);
    };

    const handleCancel = () => {
        setShowExplanationForm(false);
        setExplanation('');
        setExplanationError('');
        onClose();
    };

    const handleBackToOptions = () => {
        setShowExplanationForm(false);
        setExplanation('');
        setExplanationError('');
    };

    return (
        <div className="popup-overlay" style={{ zIndex: 1000 }}>
            <div className="popup" style={{ width: '550px', maxHeight: '80vh', overflow: 'auto' }}>
                <h2 style={{ marginBottom: '15px', color: '#333' }}>
                    NSS Trunk Removal Confirmation
                </h2>
                <hr style={{ marginBottom: '15px' }} />

                {!showExplanationForm ? (
                    <>
                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ marginBottom: '10px' }}>
                                You are removing the following trunk from customer <strong>{trunkData.customerName}</strong>:
                            </p>
                            <div style={{
                                backgroundColor: '#f5f5f5',
                                padding: '10px',
                                borderRadius: '4px',
                                marginBottom: '15px'
                            }}>
                                <p><strong>Trunk ID:</strong> {trunkData.value}</p>
                                <p><strong>Trunk Name:</strong> {trunkData.name}</p>
                            </div>

                            <div style={{
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                padding: '15px',
                                borderRadius: '4px',
                                marginBottom: '15px'
                            }}>
                                <p style={{ fontWeight: 'bold', color: '#856404' }}>
                                    Do you want to remove Attest A and Attest B numbers from NSS for this trunk?
                                </p>
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button
                                onClick={handleCancel}
                                disabled={isLoading}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleNoClick}
                                disabled={isLoading}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                No
                            </button>
                            <button
                                onClick={handleYesClick}
                                disabled={isLoading}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isLoading ? 'Processing...' : 'Yes'}
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ marginBottom: '15px' }}>
                                Please provide an explanation for why you are removing the trunk
                                <strong> {trunkData.name}</strong> but keeping the attestation numbers in NSS.
                            </p>
                            <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
                                This explanation will be sent to the compliance team for review.
                            </p>
                            <textarea
                                value={explanation}
                                onChange={(e) => {
                                    setExplanation(e.target.value);
                                    setExplanationError('');
                                }}
                                placeholder="Enter your explanation here..."
                                style={{
                                    width: '100%',
                                    minHeight: '120px',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: explanationError ? '1px solid #dc3545' : '1px solid #ced4da',
                                    resize: 'vertical',
                                    fontSize: '14px'
                                }}
                            />
                            {explanationError && (
                                <p style={{ color: '#dc3545', fontSize: '13px', marginTop: '5px' }}>
                                    {explanationError}
                                </p>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button
                                onClick={handleBackToOptions}
                                disabled={isLoading}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Back
                            </button>
                            <button
                                onClick={handleSubmitExplanation}
                                disabled={isLoading}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isLoading ? 'Submitting...' : 'Submit Explanation'}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default NssTrunkRemovalModal;
